/** Static copy for RuntimeCoreSplash; candidate for tenant config later. */
export const RUNTIME_CORE_SPLASH_DEFAULT_STATUS = 'Starting Cortex…';
